import { KeyboardBackspace } from '@mui/icons-material'
import { capitalize, Chip, IconButton, Paper, Stack, Tab, Tabs, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import Dashboard from '../../../components/Layouts/dashboardLayout'
import { useBookingById } from '../hooks/useBookingById'
import BookingInfo from './BookingInfo'
import JobCards from './JobCards'

function TabPanel(props) {
    const { children, value, index } = props
    return <>{value === index && <>{children}</>}</>
}

const BookingById = () => {
    const { selectedTab, handelTabChange, booking } = useBookingById()
    const navigate = useNavigate()
    return (
        <>
            <Dashboard>
                <Stack spacing={2}>
                    <Paper sx={{ p: 2 }}>
                        <Stack direction="row" alignItems="center">
                            <IconButton
                                onClick={() => {
                                    navigate(-1)
                                }}
                                sx={{
                                    p: 0,
                                    mr: 2,
                                }}
                                color="inherit"
                            >
                                <KeyboardBackspace
                                    fontSize="inherit"
                                    sx={{
                                        fontSize: '32px',
                                    }}
                                />
                            </IconButton>
                            <Stack>
                                <Typography variant="h5" fontWeight={600}>
                                    {booking?.jobType
                                        .split('_')
                                        .map((item) => capitalize(item))
                                        .join(' ')}
                                    <Chip sx={{ ml: 2 }} label={booking?.status} />
                                </Typography>
                                <Typography variant="caption" fontWeight={400}>
                                    ID: {booking?.bookingId}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Paper>
                    <Paper>
                        <Tabs value={selectedTab} onChange={handelTabChange}>
                            <Tab value="info" label="Booking Info"></Tab>
                            <Tab value="allocation" label="Allocated Heros"></Tab>
                        </Tabs>
                        <TabPanel value={selectedTab} index={'info'}>
                            <BookingInfo bookingInfo={booking} />
                        </TabPanel>
                        <TabPanel value={selectedTab} index={'allocation'}>
                            <JobCards bookingInfo={booking} />
                        </TabPanel>
                    </Paper>
                </Stack>
            </Dashboard>
        </>
    )
}

export default BookingById
